import React from 'react';
import styled from 'styled-components';
import media from '../../../utils/media';
import { RichP1, RichH3, RichH4 } from '../../Typography';
import { Image } from '../../Image';
import { isFieldValid } from '../../../utils/validation';
import { CTALink } from '../../Link';
import { getParsedField } from '../../../utils/helpers';
const Container = styled.div `
  text-align: left;
  width: 540px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${media.mobile} {
    width: 100%;
  }

  *:last-child {
    margin-bottom: 0px !important;
  }
`;
const ContentSubtitle = styled(RichH4) `
  color: ${({ theme }) => theme.primaryRed};
  margin-bottom: 20px;
  width: 100%;

  ${media.mobile} {
    margin-bottom: 20px;
  }
`;
const ContentTitle = styled(RichH3) `
  width: 100%;
  margin-bottom: 10px;
`;
const ContentBodyText = styled(RichP1) `
  width: 100%;
  margin-bottom: 20px;
`;
const Logo = styled(Image) `
  height: 60px;
  width: auto;
  margin-bottom: 20px;
`;
// This component is used for both TabImage and TabVideo
export const TabMediaText = ({ fields }) => {
    if (!fields) {
        return null;
    }
    const { logoImage, contentSubtitle, contentTitle, contentBodyText, ctaLink, ctaLinkText, ctaType } = fields;
    const parsedTitle = getParsedField(contentTitle);
    const parsedSubtitle = getParsedField(contentSubtitle);
    const parsedBodyText = getParsedField(contentBodyText);
    return (React.createElement(Container, null,
        isFieldValid(logoImage, 'src') && React.createElement(Logo, { field: logoImage }),
        isFieldValid(contentSubtitle) && !isFieldValid(logoImage, 'src') && (React.createElement(ContentSubtitle, { field: parsedSubtitle })),
        isFieldValid(contentTitle) && React.createElement(ContentTitle, { field: parsedTitle }),
        isFieldValid(contentBodyText) && React.createElement(ContentBodyText, { field: parsedBodyText }),
        isFieldValid(ctaLink, 'href') && isFieldValid(ctaLinkText) && (React.createElement(CTALink, { field: ctaLink, textField: ctaLinkText, typeField: ctaType }))));
};
